(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-tabbed"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const tabbedMenus = document.querySelectorAll('.mega-menu__tabbed');

    tabbedMenus.forEach(menu => {
      const tabs = menu.querySelectorAll('.menu-tab');
      const contents = menu.querySelectorAll('.tab-content');

      if (!tabs.length || !contents.length) return;

      const activate = (index) => {
        tabs.forEach((tab, i) => tab.classList.toggle('active', i === index));
        contents.forEach((content, i) => content.classList.toggle('active', i === index));
      };

      activate(0);

      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', () => activate(index));
      });

      // menu.addEventListener('pointerleave', () => activate(0));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    const btn = document.querySelector('.scroll-to-top');
    if (!btn) return;

    const threshold = 0.3;
    let ticking = false;

    function onScroll() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
        const scrolled = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? scrolled / docHeight : 0;

        if (scrollPercent >= threshold) {
        btn.classList.add('is-visible');
        } else {
        btn.classList.remove('is-visible');
        }
        ticking = false;
    });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    });
})();
  } catch(e) { console.error(e); }
})();

})();
